import "../styles/AssetSummaryCard.css";

const toText = (value) => String(value ?? "").trim();

const isDisplayEmpty = (value) => {
  const normalized = toText(value).toLowerCase();
  return (
    !normalized ||
    normalized === "-" ||
    normalized === "--" ||
    normalized === "n/a" ||
    normalized === "null"
  );
};

const AssetSummaryCard = ({
  assetId,
  title,
  subtitle,
  statusLabel = "",
  statusColor = "",
  rows = [],
}) => {
  const visibleRows = (Array.isArray(rows) ? rows : []).filter(
    (row) => row?.label && !isDisplayEmpty(row?.value)
  );

  return (
    <div className="asset_summary_card">
      <div className="asset_summary_card_header">
        <div className="asset_summary_card_heading">
          <span className="asset_summary_card_id">{toText(assetId) || "--"}</span>
          <h3>{toText(title) || "--"}</h3>
          {!isDisplayEmpty(subtitle) ? (
            <p className="asset_summary_card_subtitle">{subtitle}</p>
          ) : null}
        </div>

        {!isDisplayEmpty(statusLabel) ? (
          <span
            className="asset_summary_card_status"
            style={
              statusColor
                ? {
                    color: statusColor,
                    borderColor: `${statusColor}33`,
                    background: `${statusColor}12`,
                  }
                : undefined
            }
          >
            {statusLabel}
          </span>
        ) : null}
      </div>

      {visibleRows.length ? (
        <div className="asset_summary_card_grid">
          {visibleRows.map((row) => (
            <div key={row.label} className="asset_summary_card_item">
              <span>{row.label}</span>
              <strong>{row.value}</strong>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default AssetSummaryCard;
